'use client';

import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { RtFrame } from '@dpa/react-frame-pulse';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const BLOCK_NAME = 'Navigation-button';
const cn = classnames.bind(styles);

export const NavigationButton = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<'button'>
>(({ className, ...props }, ref) => (
  <RtFrame
    {...props}
    ref={ref}
    as="button"
    className={cn(BLOCK_NAME, className)}
    type="button"
  />
));

NavigationButton.displayName = 'NavigationButton';
